import React from 'react';
import { Colors } from './theme/Colors';
import { ReactComponent as AppleShare } from './images/apple_share.svg';
import { ReactComponent as UserSlash } from './svg/user-slash.svg';
import { ReactComponent as GoogleLogo } from './svg/icons8-google.svg';
import { ReactComponent as TikTok } from './svg/tiktok.svg';
import { ReactComponent as FrusLogo } from './svg/frus-logo.svg';
import { ReactComponent as FoodDonorSlash } from './svg/donor-slash.svg';

export const TikTokIcon = ({ htmlColor, ...rest }) => (
  <TikTok
    style={{
      padding: '0px 4px',
      fill: htmlColor || Colors.black,
    }}
    {...rest}
  />
);

export const FrusLogoIcon = props => (
  <FrusLogo
    style={{
      padding: '0px 4px 4px',
      fill: props.htmlColor || Colors.black,
    }}
    {...props}
  />
);

export const AppleShareIcon = props => {
  return <AppleShare {...props} />;
};

export const UserSlashIcon = props => {
  return <UserSlash {...props} />;
};

export const FoodDonorSlashIcon = props => {
  return <FoodDonorSlash {...props} />;
};

export const GoogleLogoIcon = props => {
  return <GoogleLogo style={{ backgroundColor: Colors.white }} {...props} />;
};

export const AppleLogoIcon = ({ width = 24, height = 24, ...rest }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"
      fill="#FFFFFF"
    />
  </svg>
);
